export default "__VITE_ASSET__DcnfcRyL__"